<form [hidden]="activeStep > stepIndex">
    <div id="payment-element">
        <!-- Stripe will create form elements here -->
    </div>
</form>
<ng-container *ngIf="activeStep > stepIndex">
    <div id="card-details" class="set-content">
        <span>
            <strong>{{ 'billing_payment_methods' | myLbTranslate }}:</strong>
            {{ paymentCompleteDetails.paymentMethodTypes }}
        </span>
        <span>
            <strong>{{ 'billing_payment_status' | myLbTranslate }}:</strong>
            {{ paymentCompleteDetails.status }}
        </span>
    </div>
</ng-container>
